import { makeStyles } from '@material-ui/core/styles';
import { borderRadius } from '../../../../styles/themes/vad/borderRadius';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import { fontSize } from '../../../../styles/themes/vad/font';

const useStyles = makeStyles(theme => {
  return {
    root: {
      position: 'relative',
      '& .sr-only': {
        position: 'absolute',
        width: '1px',
        height: '1px',
        margin: '-1px',
        padding: '0',
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        border: '0'
      },
      '& svg': {
        maxWidth: 'none',
        maxHeight: 'none',
        '& path': {
          stroke: theme.mixins.Black(),
        },
      },
      '& .gm-style-iw-c': {
        borderRadius: borderRadius.b0,

        '& > button': {
          display: 'none !important',
          opacity: 0,
        },
      },
      '& .gm-style .gm-style-iw-t::after': {
        background: 'transparent',
        boxShadow: 'none',
      },

      '& .baidu-infoWindow': {
        '& a': {
          textDecoration: 'none',
          fontSize: fontSize.s16Rem,
        },
        '& h4': {
          fontFamily: theme.custom.fontFamily.primaryBold,
          marginBottom: pxToRem(5),
        },
        '& p': {
          fontSize: fontSize.s16Rem,
          marginBottom: pxToRem(8),

          [theme.breakpoints.up('lg')]: {
            fontSize: fontSize.s20Rem,
          },
        },
        '& .MuiButton-root': {
          fontSize: 'inherit',
          color: theme.mixins.AbuDhabiOrange(),
          marginLeft: pxToRem(-5),
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
        '& svg path': {
          stroke: 'none',
        },
      },
      '& #map_canvas': {
        backgroundColor: theme.palette.background.default,
      },
    },
    infoBox: {
      height: pxToRem(100),
    },
    holder: {
      position: 'relative',
      height: pxToRem(468),

      [theme.breakpoints.down('lg')]: {
        marginLeft: '-1.5rem',
        marginRight: '-1.5rem',
      },
      [theme.breakpoints.up('lg')]: {
        height: pxToRem(768),
      },
    },
    legends: {
      backgroundColor: theme.palette.common.white,
      padding: pxToRem(20),

      '&.overlay': {
        position: 'absolute',
        bottom: pxToRem(24),
        left: pxToRem(12),
        width: pxToRem(300),
        boxShadow: theme.shadows[1],
        padding: pxToRem(15),

        [theme.breakpoints.up('lg')]: {
          width: pxToRem(415),
          padding: pxToRem(20),
        },
      },
    },
    list: {
      paddingLeft: pxToRem(10),
      margin: 0,

      [theme.breakpoints.up('lg')]: {
        borderBottom: theme.borders.divider,
        paddingBottom: pxToRem(20),
        marginBottom: pxToRem(20),
      },
    },
    infoWindow: {
      maxWidth: pxToRem(415),
      padding: `${pxToRem(5)} ${pxToRem(10)}`,
    },
    address: {
      color: theme.palette.text.tertiary,
      fontSize: fontSize.s16Rem,
    },
    directionBtn: {
      fontSize: fontSize.s16Rem,
      marginTop: 0,
      marginLeft: '-5px',

      '& .MuiButton-startIcon': {
        padding: 0,
        marginLeft: 0,
      },

      '& svg path': {
        stroke: 'none',
      },
    },
  };
});

export default useStyles;
